// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__144d7","content":"styles_content__22THM","checkbox":"styles_checkbox__31lsv","checkboxLabel":"styles_checkboxLabel__1yMXR"};